export class MenuScroll {
    constructor(options = {}) {
        this.headerSelector = options.headerSelector || '.header';
        this.deepBlueSelector = options.deepBlueBlock || '.deepblue-bg';
        this.userPanelSelector = options.userPanelSelector || '.user-panel';
        this.threshold = options.threshold || 0.7;
        this.ticking = false;
    }

    get isBankPage() {
        return !!document.querySelector('.bank-container__aside');
    }

    // get isPage404() {
    //     const input = document.querySelector('input[name="is404"]');
    //     return !!input && input.value === 'Y';
    // }

    init() {
        this.header = document.querySelector(this.headerSelector);
        this.blueBlock = document.querySelector(this.deepBlueSelector);
        this.userPanel = document.querySelector(this.userPanelSelector);

        if (!this.header) return;

        this.nodes = {
            bar: this.header.querySelector('.header__bar'),
            barBtn: this.header.querySelector('.bar__btn'),
            logo: this.header.querySelector('.header__logo'),
            menu: this.header.querySelector('.main-menu'),
            nav: this.header.querySelector('.header__nav'),
            social: this.header.querySelector('.social')
        };

        if (!this.blueBlock) {
            this.setupDefaultState();
        } else {
            this.bindEvents();
            this.check();
        }

    }

    setupDefaultState() {
        this.header.classList.remove('header--light');
        this.header.classList.add('header--fixed');
        this.header.style.top = '0px';
        this.updateElementsTheme(false);
        if (this.nodes.bar) this.nodes.bar.classList.add('header__bar--active');
    }

    bindEvents() {
        window.addEventListener('scroll', () => {
            if (!this.ticking) {
                window.requestAnimationFrame(() => {
                    this.check();
                    this.ticking = false;
                });
                this.ticking = true;
            }
        }, { passive: true });
        window.addEventListener('resize', () => this.check(), { passive: true });
    }

    check() {
        if (!this.blueBlock) return;
        const blueRect = this.blueBlock.getBoundingClientRect();
        const blockHeight = blueRect.height;
        const triggerPoint = blockHeight * this.threshold;

        const beFixed = blueRect.bottom <= triggerPoint;
        this.updateUI(beFixed, blueRect.bottom);

        this.checkUserPanelDistance();
    }

    checkUserPanelDistance() {
        if (!this.userPanel || !this.header || !this.blueBlock) return;

        const headerRect = this.header.getBoundingClientRect();
        const panelRect = this.userPanel.getBoundingClientRect();
        const blueRect = this.blueBlock.getBoundingClientRect();

        const isStillOnBlue = blueRect.bottom > panelRect.bottom;
        const distanceBelow = panelRect.top - headerRect.bottom;
        const distanceAbove = headerRect.top - panelRect.bottom;

        let isTooClose = false;

        if (isStillOnBlue) {
            if (distanceBelow < 120 && distanceBelow > -panelRect.height) {
                isTooClose = true;
            } else if (distanceAbove < 20 && distanceAbove > -headerRect.height) {
                isTooClose = true;
            }
        }

        this.userPanel.classList.toggle('user-panel--hidden', isTooClose);
    }

    updateUI(beFixed, currentBottom) {
        this.header.classList.toggle('header--fixed', beFixed);

        if (beFixed) {
            const topValue = Math.max(0, Math.floor(currentBottom));
            this.header.style.top = `${topValue}px`;

            this.header.classList.remove('header--light');
            this.updateElementsTheme(false);

            if (this.nodes.bar) {
                this.nodes.bar.classList.add('header__bar--active');
            }
        } else {
            this.header.style.top = '';
            this.header.classList.add('header--light');
            this.updateElementsTheme(true);

            if (this.nodes.bar) {
                this.nodes.bar.classList.remove('header__bar--active');
            }

            // Убираем старое меню Битрикса, если оно было открыто
            if (this.nodes.menu) {
                this.nodes.menu.classList.remove('main-menu--opened');
            }

            // Сбрасываем визуальные состояния кнопки и бара при возврате наверх
            if (this.nodes.barBtn) {
                this.nodes.barBtn.classList.remove('bar__btn--active');
            }
            if (this.nodes.bar) {
                this.nodes.bar.classList.remove('header__bar--active-click');
            }
        }
    }

    updateElementsTheme(isLight) {

        this.toggleChild(this.nodes.logo, 'header__logo--light', isLight);
        this.toggleChild(this.nodes.menu, 'main-menu--light', isLight);
        this.toggleChild(this.nodes.nav, 'header__nav--light', isLight);

        const shouldSocialBeLight = this.hasBankAside ? true : isLight;

        const socialState = this.isBankPage ? true : isLight;
        this.toggleChild(this.nodes.social, 'social--light', socialState);

        const input = document.querySelector('input[name="is404"]');
        if (input && input.value === 'Y' && this.nodes.social) {
            this.nodes.social.classList.remove('social--add-light');
        }

        this.toggleChild(this.userPanel, 'user-panel--light', isLight);
        // Добавляем переключение темы для самой кнопки бургера, если нужно
        this.toggleChild(this.nodes.barBtn, 'bar__btn--light', isLight);
    }

    toggleChild(el, className, state) {
        if (el) el.classList.toggle(className, state);
    }

}